import { AppFooter } from 'components/app/AppFooter';
import { AppHeader } from 'components/app/AppHeader';
import React, { useEffect } from 'react';
import styled from 'styled-components';

export const LayoutDefault: React.FC<{ children: React.ReactNode }> = (props) => {
  return (
    <CptStyles>
      <AppHeader />
      {props.children}
      <AppFooter />
    </CptStyles>
  );
};

const CptStyles = styled.div`
  width: 100vw;
`;
